module.exports = __webpack_public_path__ + "img/DealerIcons-T2-On.c9c9633.jpg";